<template>
    <v-dialog
        width="1000"
        :hide-overlay="true"
        :persistent="true"
        v-model="watchlistModal"
    >
        <v-card class="pt-0">
            <v-app-bar
                flat
                color="rgba(0, 0, 0, 0)"
                style="background: rgb(26, 57, 88)"
            >
                <v-toolbar-title class="text-h6 white--text pl-0">
                    {{ $t("alertHub.watchlistDetail") }}
                </v-toolbar-title>
                <v-spacer />

                <v-btn color="white" icon @click="closeModal"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-app-bar>

            <v-card-actions>
                <v-row>
                    <v-col cols="2"><strong>{{ $t("common.table.login") }}</strong></v-col>
                    <v-col cols="4">{{ watchlistData.login }}</v-col>

                    <v-col cols="2"><strong>{{ $t("common.table.server") }}</strong></v-col>
                    <v-col cols="4">{{ watchlistData.server_name }}</v-col>

                    <v-col cols="2"><strong>Book</strong></v-col>
                    <v-col cols="4">{{ watchlistData.book }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.accountCCY") }}</strong></v-col>
                    <v-col cols="4">{{ watchlistData.currency }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.equityUSD") }}</strong></v-col>
                    <v-col cols="4">{{
                        numberWithCommas(
                            (watchlistData.equity_usd || 0).toFixed(2)
                        )
                    }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.balanceUSD") }}</strong></v-col>
                    <v-col cols="4">{{
                        numberWithCommas(
                            (watchlistData.balance_usd || 0).toFixed(2)
                        )
                    }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.totalPNLUSD") }}</strong></v-col>
                    <v-col cols="4">{{
                        numberWithCommas((watchlistData.profit || 0).toFixed(2))
                    }}</v-col>

                    <v-col cols="2"><strong>DPM</strong></v-col>
                    <v-col cols="4">{{
                        (watchlistData.dpm || 0).toFixed(2)
                    }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.volumeUSD") }}</strong></v-col>
                    <v-col cols="4">{{
                        numberWithCommas(
                            (watchlistData.volume_usd || 0).toFixed(2)
                        )
                    }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.category") }}</strong></v-col>
                    <v-col cols="4">{{
                        (watchlistData.hashtag || [])
                            .map((tag) => tag.name)
                            .join(", ")
                    }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.status") }}</strong></v-col>
                    <v-col cols="4">{{ watchlistData.status_name }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.assignee") }}</strong></v-col>
                    <v-col cols="4">{{ getAssignee(watchlistData.user_ids )}}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.createdBy") }}</strong></v-col>
                    <v-col cols="4">{{
                        watchlistData.watchlist_create_user
                    }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.updatedAt") }}</strong></v-col>
                    <v-col cols="4">{{
                        (watchlistData.watchlist_updated_at || "")
                            .split(".")[0]
                            .replace("T", " ")
                    }}</v-col>

                    <v-col cols="2"><strong>{{ $t("alertHub.comment") }}</strong></v-col>
                    <v-col cols="10">{{ watchlistData.comment_text }}</v-col>
                </v-row>
            </v-card-actions>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="orange darken-1"
                    text
                    @click="
                        redirectTo(watchlistData.login, watchlistData.server_id)
                    "
                    >To Edit</v-btn
                >
                <v-btn color="green darken-1" text @click="closeModal"
                    >{{ $t("common.form.close") }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { redirectToRH } from "@utils/util";
import { helper } from "@components/mixins/helper";

export default {
    mixins: [helper],
    props: {
        watchlistModal: false,
        watchlistData: null,
        closeModal: Function,
    },
    computed: {
        ...mapState("AlertHub", ["listRHUser"]),
    },
    methods: {
        getAssignee(id) {
            if (id?.length > 0) {
                return this.listRHUser.find((user) => user.id === id[0])
                    ?.username;
            }
            return "";
        },
        redirectTo(login) {
            let url = `/watch-list?mode=edit&login=${login}`;
            redirectToRH(url);
        },
    },
};
</script>
